import axios from "axios";
import store from "../../../../index"

class Common {
    doPost = (url, param, afterFunc, errorFunc) => {

        axios.post(url, param).then((res) => {
            afterFunc(res);
        }).catch((err) => {
            if (errorFunc) {
                errorFunc();
            }
            console.log(err);
        })
    }
    doPostRef = (url, param, ref, afterFunc, errorFunc) => {

        axios.post(url, param).then((res) => {
            afterFunc(res, ref);
        }).catch((err) => {
            if (errorFunc) {
                errorFunc();
            }
            console.log(err);
        })
    }
    scrollWindow = (elem) => {
        let element = document.getElementById(elem);
        if (element != null) {
            let rect = element.getBoundingClientRect();
            let elemtop = rect.top + window.pageYOffset;

            window.scroll({
                top: elemtop, // スクロール量の設定
                behavior: 'smooth' // スクロール動作の設定
            });
        }
    }
    scrollWindowTop = () => {
        window.scrollTo(0, 0);
    }
    versionCheck = (dbver) => {
        try {
            let versionStorage = "";
            versionStorage = store.getState().version;
            console.log("strageVer" + versionStorage);
            //DBのバージョン
            const versionSource = dbver;
            console.log("sourceVer" + versionSource);
            if (versionSource != versionStorage) {
                //store,storage初期化
                let rtccFlg = store.getState().rtccFlg;
                let catalogFlg = store.getState().catalogFlg;
                let area = store.getState().area;
                let dispArea = store.getState().dispArea;
                let country = store.getState().country;
                let dispCountry = store.getState().dispCountry;
                let city = store.getState().city;
                let dispCity = store.getState().dispCity;
                let keyWord = store.getState().keyWord;
                store.dispatch({ type: "CLEAR_STATE" });
                store.dispatch({ type: "RTCC_FLG", payload: { rtccFlg: rtccFlg } });
                if (catalogFlg){
                    store.dispatch({ type: "CATALOG_FLG", payload: { catalogFlg: catalogFlg } });
                    store.dispatch({ type: "AREA", payload: { area: area } });
                    store.dispatch({ type: "DISP_AREA", payload: { dispArea: dispArea } });
                    store.dispatch({ type: "COUNTRY", payload: { country: country } })
                    store.dispatch({ type: "DISP_COUNTRY", payload: { dispCountry: dispCountry } });
                    store.dispatch({ type: "CITY", payload: { city: city } })
                    store.dispatch({ type: "DISP_CITY", payload: { dispCity: dispCity } });
                    store.dispatch({ type: "KEYWORD", payload: { keyWord: keyWord } });
                }
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            console.log(e.message);
            return false;
        }
    }

    logout = () => {
        store.dispatch({ type: "CLEAR_STATE" });
    }
}


export default new Common();